import React from 'react';
import {Box, Checkbox, CheckboxProps, FormControlLabel, Link, Typography} from '@mui/material';

const PWMCheckboxControl: React.FC<IPWMCheckboxControlProps> = (props) => {
  const onCheck = (event: any) => {
    if(props.onChecked) {
      return props.onChecked(event.target.checked);
    }
    if(props.onChange){
      return props.onChange(event);
    }
  };

  const checkProps: Pick<CheckboxProps, 'defaultChecked' | 'checked'> = {};
  if(props.defaultChecked !== undefined){
    checkProps['defaultChecked'] = props.defaultChecked;
  } else if(props.isChecked !== undefined) {
    checkProps['checked'] = props.isChecked;
  }

  const checkboxComponent = <Checkbox
    id={props.id}
    required={props.required}
    disabled={props.disabled}
    name={props.name}
    onChange={onCheck}
    {...checkProps}
  />;

  const checkboxOrCheckboxLabelComponent = (props.label && props.link) ? (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        ml: -1,
        mt: 1
      }}
    >
      <Checkbox
        id={props.id}
        required={props.required}
        disabled={props.disabled}
        name={props.name}
        onChange={onCheck}
        {...checkProps}
      />
      {props.label && (
        props.link ? (
          <Link
            component="a"
            href={props.link}
          >
            {props.label}
          </Link>
        ) : <Typography
          color="text.secondary"
          variant="body2"
        >
          {props.label}
        </Typography>
      )}
    </Box>
  ) : props.label ? (
    <FormControlLabel
      value="start"
      control={checkboxComponent}
      label={props.label}
      labelPlacement={props.labelPlacement ?? 'start'}
    />
  ) : (
    checkboxComponent
  );

  return (
    checkboxOrCheckboxLabelComponent
  );
};

export default PWMCheckboxControl;

interface IPWMCheckboxControlProps {
  onChecked?(checked: boolean): any;
  onChange?(e: InputEvent): any;
  id?: string;
  name: string;
  isChecked?: boolean;
  labelPlacement?: 'top' | 'bottom' | 'end' | 'start';
  defaultChecked?: boolean;
  required?: boolean;
  disabled?: boolean;
  children?: React.ReactNode;
  label?: string;
  link?: string;
}